import { useTranslation } from 'react-i18next'
import { Button, TextField, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material'

const AddSubjectDialog = ({ open, onClose, subjectName, setSubjectName, onAdd }) => {
  const { t } = useTranslation('common')

  return (
    <Dialog open={open != null} onClose={onClose} fullWidth maxWidth="xs">
      <DialogTitle>{t('syllabus.new_subject_dialog')}</DialogTitle>
      <DialogContent dividers>
        <TextField
          fullWidth
          label={t('syllabus.name_label')}
          value={subjectName}
          onChange={(e) => setSubjectName(e.target.value)}
          margin="normal"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('common.cancel')}</Button>
        <Button variant="contained" onClick={onAdd}>
          {t('syllabus.add_btn')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default AddSubjectDialog
